import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { SVGS } from '../../assets';
import { CommonButton } from '../../components';
import './trip-info-modal.scss';
import { TripInfoTaskType } from '../../types';
import {
  getCurrentCustomer,
  getCustomerInfo,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { TouchableOpacity } from '../../common';

interface TripInfoModalProps {
  open: boolean;
  type: TripInfoTaskType;
  onClose: () => void;
  onPrimaryPress: () => void;
  onSecondaryPress?: () => void;
}

export const TripInfoModal: React.FC<TripInfoModalProps> = ({
  open,
  type,
  onClose,
  onPrimaryPress,
  onSecondaryPress,
}) => {
  const customerInfo = useAppSelector(getCustomerInfo);
  const currentCustomer = useAppSelector(getCurrentCustomer);

  const tripInfoConfig = {
    [TripInfoTaskType.NOT_CLOCKED_IN]: {
      image: SVGS.NoClockInIcon,
      heading: 'Clock In Required',
      subHeading: 'You need to clock in before performing any\nother actions.',
      primaryText: 'Clock In',
      secondaryText: '',
    },
    [TripInfoTaskType.ALREADY_CHECKED_IN]: {
      image: SVGS.ConfirmCheckOut,
      heading: 'Existing Check In',
      subHeading: `You have already checked in for ${customerInfo?.customerName},\nCheck out and check in to ${currentCustomer?.customerName}.`,
      primaryText: `Check Out & Check In`,
      secondaryText: '',
    },
    [TripInfoTaskType.NOT_CHECKED_OUT]: {
      image: SVGS.ConfirmCheckOut,
      heading: 'Missed Check Out',
      subHeading: `You haven't finished last trip for\n${customerInfo?.customerName}.`,
      primaryText: `Check Out`,
      secondaryText: '',
    },
    [TripInfoTaskType.NOT_CHECKED_IN]: {
      image: SVGS.CheckInRequireIcon,
      heading: 'Check In Required',
      subHeading: 'You need to check in before performing any\nother actions.',
      primaryText: `Check In`,
      secondaryText: '',
    },
    [TripInfoTaskType.NOT_SYNCED_LOG_OUT]: {
      image: SVGS.PendingActivity,
      heading: 'Pending Activities',
      subHeading: 'You have pending activities,\nsync before log-out',
      primaryText: `Go to Sync`,
      secondaryText: 'Discard Activities & Log Out',
    },
    [TripInfoTaskType.NOT_SYNCED_CLOCK_OUT]: {
      image: SVGS.PendingActivity,
      heading: 'Pending Activities',
      subHeading: 'You have pending activities,\nsync before clock-out',
      primaryText: `Go to Sync`,
      secondaryText: 'Discard Activities & Clock Out',
    },
    [TripInfoTaskType.NOT_SYNC]: {
      image: SVGS.PendingActivity,
      heading: 'Pending Activities',
      subHeading: 'You have pending activities, sync',
      primaryText: `Go to Sync`,
      secondaryText: 'Discard Activities',
    },
  };

  const config = tripInfoConfig?.[type];

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen
      PaperProps={{ className: 'trip-info-modal__drawer' }}
    >
      <Box className="trip-info-modal__container">
        <div className="trip-info__pending">
          <img src={config?.image} width={135} height={135} />
          <div className="trip-info__required-message">
            <span className="trip-info__required-message__heading font-semibold">
              {config?.heading}
            </span>
            <br />
            <span className="trip-info__required-message__sub-heading font-regular">
              {config?.subHeading}
            </span>
          </div>
        </div>

        <CommonButton text={config?.primaryText} onPress={onPrimaryPress} />
        {config?.secondaryText && (
          <TouchableOpacity
            onPress={() => onSecondaryPress?.()}
            className="trip__secondary-btn"
          >
            <div className="trip__secondary-btn-text font-semibold">
              {config?.secondaryText}
            </div>
          </TouchableOpacity>
        )}
      </Box>
    </SwipeableDrawer>
  );
};
